import { useField } from 'formik';
import { useRef } from 'react';
import { fieldName } from '../../../../../../utils';
import Button, { PlaceholderButton } from '../../../../../common/base/Button';
import { IconName } from '../../../../../common/base/Icon';
import Text from '../../../../../common/base/Text';
import { Div } from '../../../../../common/helpers/StyledUtils';
import TextInput from '../../../../../common/Form/Fields/TextInput';
import { StyledCardSection } from '../../../../../common/base/Card';
const Variables: React.FC<{
  name: string;
}> = ({
  name
}) => {
  const [{
    value: env
  },, {
    setValue: setEnv,
    setTouched: setTouchedEnv
  }] = useField(name);
  const [{
    value: vars
  },, {
    setValue: setVars
  }] = useField('vars');
  const renderKeyRef = useRef(new Date().getTime());
  const curriedRemoveEntry = (index: number) => () => {
    const new_env = [...env];
    new_env.splice(index, 1);
    setEnv(new_env);
    renderKeyRef.current = new Date().getTime();
  };
  return <>
      <StyledCardSection p={4}>
        <Text as="p" m={{
        b: 4
      }}>
          Variables are AES encrypted. Refer to the value using{' '}
          <code>process.env.VARIABLE_KEY</code>.
        </Text>
        {vars.map((_, i) => <div key={`${renderKeyRef.current}-${i}`}>
            <Div flex={{
          align: 'center',
          gap: 3
        }} m={{
          t: i === 0 ? 0 : 3
        }}>
              <TextInput w={100} m={0} name={fieldName(`[${i}][0]`, 'vars')} placeholder={'Key'} />
              <TextInput w={100} m={0} name={fieldName(`[${i}][1]`, 'vars')} placeholder={'Value'} />
              <Button outline ghost large icon={'delete' as IconName} disabled={i === 0 && vars.length === 1} onClick={curriedRemoveEntry(i)} />
            </Div>
          </div>)}
        <PlaceholderButton m={{
        t: 3
      }} p={1.5} onClick={() => setVars([...vars, ['', '']])}>
          Add new variable
        </PlaceholderButton>
      </StyledCardSection>
      <StyledCardSection p={{
      x: 4,
      y: 3
    }} flex={{
      justify: 'flex-end',
      align: 'center',
      gap: 3
    }}>
        <Button outline onClick={() => setVars(env)}>
          Cancel
        </Button>
        <Button primary onClick={() => {
        setEnv(vars);
        setTouchedEnv(true);
      }}>
          Apply
        </Button>
      </StyledCardSection>
    </>;
};
export default Variables;